export var ClientIDType;
(function (ClientIDType) {
    ClientIDType["tax_id_number"] = "tax_id_number";
    ClientIDType["personal_id_number"] = "personal_id_number";
    ClientIDType["passport_number"] = "passport_number";
    ClientIDType["vat_number"] = "vat_number";
    ClientIDType["tax_number"] = "tax_number";
    ClientIDType["social_security_number"] = "social_security_number";
    ClientIDType["tax_id_number_local"] = "tax_id_number_local";
    ClientIDType["personal_id_number_local"] = "personal_id_number_local";
    ClientIDType["tax_id_number_local_jbkjs"] = "tax_id_number_local_jbkjs";
    ClientIDType["retiree_card_number"] = "retiree_card_number";
    ClientIDType["agricultural_holding_tax_id_number"] = "agricultural_holding_tax_id_number";
    ClientIDType["agricultural_holding_personal_id_number"] = "agricultural_holding_personal_id_number";
    ClientIDType["agricultural_holding_id_number"] = "agricultural_holding_id_number";
    ClientIDType["personal_id_card_number"] = "personal_id_card_number";
    ClientIDType["resident_number_refugee"] = "resident_number_refugee";
    ClientIDType["resident_number_foreign"] = "resident_number_foreign";
    ClientIDType["passport_number_local"] = "passport_number_local";
    ClientIDType["passport_number_foreign"] = "passport_number_foreign";
    ClientIDType["resident_number_diplomat"] = "resident_number_diplomat";
    ClientIDType["personal_id_card_number_mkd"] = "personal_id_card_number_mkd";
    ClientIDType["personal_id_card_number_mne"] = "personal_id_card_number_mne";
    ClientIDType["personal_id_card_number_alb"] = "personal_id_card_number_alb";
    ClientIDType["personal_id_card_number_bih"] = "personal_id_card_number_bih";
    ClientIDType["personal_id_card_number_eur"] = "personal_id_card_number_eur";
    ClientIDType["tax_id_number_foreign"] = "tax_id_number_foreign";
})(ClientIDType || (ClientIDType = {}));
export var ClientTransactionBasisType;
(function (ClientTransactionBasisType) {
    ClientTransactionBasisType["sale"] = "sale";
    ClientTransactionBasisType["order"] = "order";
    ClientTransactionBasisType["summary"] = "summary";
    ClientTransactionBasisType["refund"] = "refund";
    ClientTransactionBasisType["advance"] = "advance";
    ClientTransactionBasisType["credit_note"] = "credit_note";
    ClientTransactionBasisType["payment"] = "payment";
    ClientTransactionBasisType["write_off"] = "write_off";
    ClientTransactionBasisType["client_sale"] = "client_sale";
    ClientTransactionBasisType["client_order"] = "client_order";
    ClientTransactionBasisType["client_summary"] = "client_summary";
    ClientTransactionBasisType["client_refund"] = "client_refund";
    ClientTransactionBasisType["client_advance"] = "client_advance";
    ClientTransactionBasisType["client_credit_note"] = "client_credit_note";
    ClientTransactionBasisType["client_payment"] = "client_payment";
    ClientTransactionBasisType["client_write_off"] = "client_write_off";
})(ClientTransactionBasisType || (ClientTransactionBasisType = {}));
export var ClientTransactionType;
(function (ClientTransactionType) {
    ClientTransactionType["manual"] = "manual";
    ClientTransactionType["auto"] = "auto";
})(ClientTransactionType || (ClientTransactionType = {}));
export var OrderRegisterType;
(function (OrderRegisterType) {
    OrderRegisterType["fiscal"] = "fiscal";
    OrderRegisterType["einvoice"] = "einvoice";
    OrderRegisterType["manual"] = "manual";
    OrderRegisterType["external"] = "external";
})(OrderRegisterType || (OrderRegisterType = {}));
export var OrderStatusType;
(function (OrderStatusType) {
    OrderStatusType["new"] = "new";
    OrderStatusType["unpaid"] = "unpaid";
    OrderStatusType["paid"] = "paid";
    OrderStatusType["summary"] = "summary";
    OrderStatusType["proforma"] = "proforma";
    OrderStatusType["advance"] = "advance";
    OrderStatusType["creditNote"] = "credit_note";
    OrderStatusType["copy"] = "copy";
})(OrderStatusType || (OrderStatusType = {}));
export var PaymentTypeLabel;
(function (PaymentTypeLabel) {
    PaymentTypeLabel["cash"] = "cash";
    PaymentTypeLabel["credit_card"] = "credit_card";
    PaymentTypeLabel["invoice"] = "invoice";
    PaymentTypeLabel["credit_card_business"] = "credit_card_business";
    PaymentTypeLabel["advance"] = "advance";
    PaymentTypeLabel["check"] = "check";
    PaymentTypeLabel["voucher"] = "voucher";
    PaymentTypeLabel["mobile_money"] = "mobile_money";
    PaymentTypeLabel["other_noncash"] = "other_noncash";
})(PaymentTypeLabel || (PaymentTypeLabel = {}));
export var PaymentAdditionLabel;
(function (PaymentAdditionLabel) {
    PaymentAdditionLabel["change"] = "change";
    PaymentAdditionLabel["left_to_pay"] = "left_to_pay";
    PaymentAdditionLabel["advance_tax"] = "advance_tax";
})(PaymentAdditionLabel || (PaymentAdditionLabel = {}));
export var CustomPaymentTypeLabel;
(function (CustomPaymentTypeLabel) {
    CustomPaymentTypeLabel["no_compensation"] = "noCompensation";
    CustomPaymentTypeLabel["installments"] = "installments";
    CustomPaymentTypeLabel["mixed"] = "mixed";
    CustomPaymentTypeLabel["order"] = "order";
    /** Wire value of the receipts payment-type filter — must equal the key the
     *  server's order filter matches ('send_to_room'). */
    CustomPaymentTypeLabel["send_to_room"] = "send_to_room";
})(CustomPaymentTypeLabel || (CustomPaymentTypeLabel = {}));
export var PriceLevelingType;
(function (PriceLevelingType) {
    PriceLevelingType["manual"] = "manual";
    PriceLevelingType["auto"] = "auto";
})(PriceLevelingType || (PriceLevelingType = {}));
export var ProductType;
(function (ProductType) {
    ProductType["food"] = "food";
    ProductType["drinks"] = "drinks";
    ProductType["other"] = "other";
})(ProductType || (ProductType = {}));
export var ReportTypeLabel;
(function (ReportTypeLabel) {
    ReportTypeLabel["current_state"] = "current_state";
    ReportTypeLabel["current_state_legacy"] = "current_state_legacy";
    ReportTypeLabel["daily_report"] = "daily_report";
    ReportTypeLabel["daily_report_legacy"] = "daily_report_legacy";
    ReportTypeLabel["periodic_report"] = "periodic_report";
    ReportTypeLabel["periodic_report_legacy"] = "periodic_report_legacy";
    ReportTypeLabel["shift_report"] = "shift_report";
    ReportTypeLabel["sales_by_user_detailed"] = "sales_by_user_detailed";
    ReportTypeLabel["einvoice_report"] = "einvoice_report";
    ReportTypeLabel["manual_register_report"] = "manual_register_report";
    ReportTypeLabel["electronic_journal"] = "electronic_journal";
    ReportTypeLabel["offline_electronic_journal"] = "offline_electronic_journal";
    ReportTypeLabel["corrective_electronic_journal"] = "corrective_electronic_journal";
    ReportTypeLabel["total_sales"] = "total_sales";
    ReportTypeLabel["sales_by_client"] = "sales_by_client";
    ReportTypeLabel["sales_by_user"] = "sales_by_user";
    ReportTypeLabel["sales_by_product"] = "sales_by_product";
    ReportTypeLabel["sales_by_product_category"] = "sales_by_product_category";
    ReportTypeLabel["sales_by_product_type"] = "sales_by_product_type";
    ReportTypeLabel["sales_by_product_type_sent_to_room"] = "sales_by_product_type_sent_to_room";
    ReportTypeLabel["sales_by_product_type_and_taxes"] = "sales_by_product_type_and_taxes";
    ReportTypeLabel["sales_by_sector"] = "sales_by_sector";
    ReportTypeLabel["sales_by_table"] = "sales_by_table";
    ReportTypeLabel["sales_by_ingredient"] = "sales_by_ingredient";
    ReportTypeLabel["product_quantities"] = "product_quantities";
    ReportTypeLabel["bar_ledger"] = "bar_ledger";
})(ReportTypeLabel || (ReportTypeLabel = {}));
export var TaxRateType;
(function (TaxRateType) {
    TaxRateType["product"] = "product";
    TaxRateType["order"] = "order";
    TaxRateType["TaxOnNet"] = "TaxOnNet";
    TaxRateType["TaxOnTotal"] = "TaxOnTotal";
    TaxRateType["AmountPerQuantity"] = "AmountPerQuantity";
})(TaxRateType || (TaxRateType = {}));
export var UserStatusType;
(function (UserStatusType) {
    UserStatusType["active"] = "active";
    UserStatusType["disabled"] = "disabled";
})(UserStatusType || (UserStatusType = {}));
export var UserTransactionType;
(function (UserTransactionType) {
    UserTransactionType["transfer"] = "transfer";
    UserTransactionType["deposit"] = "deposit";
    UserTransactionType["charge"] = "charge";
})(UserTransactionType || (UserTransactionType = {}));
export var OrderTicketStatus;
(function (OrderTicketStatus) {
    OrderTicketStatus["scheduled"] = "scheduled";
    OrderTicketStatus["confirmedPreorder"] = "confirmed_preorder";
    OrderTicketStatus["accepted"] = "accepted";
    OrderTicketStatus["needsMapping"] = "needs_mapping";
    OrderTicketStatus["preparing"] = "preparing";
    OrderTicketStatus["ready"] = "ready";
    OrderTicketStatus["pickedUp"] = "picked_up";
    OrderTicketStatus["completed"] = "completed";
    OrderTicketStatus["cancelled"] = "cancelled";
})(OrderTicketStatus || (OrderTicketStatus = {}));
export var OrderTicketPaymentMethod;
(function (OrderTicketPaymentMethod) {
    OrderTicketPaymentMethod["CASH"] = "CASH";
    OrderTicketPaymentMethod["PREPAID"] = "PREPAID";
})(OrderTicketPaymentMethod || (OrderTicketPaymentMethod = {}));
export var KitchenTicketType;
(function (KitchenTicketType) {
    KitchenTicketType["dineIn"] = "dineIn";
    KitchenTicketType["pickup"] = "pickup";
    KitchenTicketType["delivery"] = "delivery";
})(KitchenTicketType || (KitchenTicketType = {}));
export var KitchenTicketStatus;
(function (KitchenTicketStatus) {
    KitchenTicketStatus["pending"] = "pending";
    KitchenTicketStatus["done"] = "done";
    KitchenTicketStatus["canceled"] = "canceled";
})(KitchenTicketStatus || (KitchenTicketStatus = {}));
export var TerminalType;
(function (TerminalType) {
    TerminalType["cashRegister"] = "cashRegister";
    TerminalType["orderingDevice"] = "orderingDevice";
    TerminalType["kitchenDisplaySystem"] = "kitchenDisplaySystem";
})(TerminalType || (TerminalType = {}));
export var TableSessionStatusType;
(function (TableSessionStatusType) {
    TableSessionStatusType["active"] = "active";
    TableSessionStatusType["closed"] = "closed";
    TableSessionStatusType["expired"] = "expired";
})(TableSessionStatusType || (TableSessionStatusType = {}));
export var BeachBookingStatusType;
(function (BeachBookingStatusType) {
    BeachBookingStatusType["confirmed"] = "confirmed";
    BeachBookingStatusType["checked_in"] = "checked_in";
    BeachBookingStatusType["checked_out"] = "checked_out";
    BeachBookingStatusType["no_show"] = "no_show";
    BeachBookingStatusType["held"] = "held";
})(BeachBookingStatusType || (BeachBookingStatusType = {}));
export var BeachPaymentStatusType;
(function (BeachPaymentStatusType) {
    BeachPaymentStatusType["pending"] = "pending";
    BeachPaymentStatusType["paid"] = "paid";
    BeachPaymentStatusType["failed"] = "failed";
})(BeachPaymentStatusType || (BeachPaymentStatusType = {}));
//# sourceMappingURL=defModels.js.map